import { useTranslation } from '@gimlite/common';
import { Form, FormType, WizardItemType, Zone } from '@gimlite/ui-v1';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ContractBaseForm } from '../../../../form/contract-create/contract-create.form';
import { CreateNewMasterPoolContractWizardContext } from '../../createNewMasterPoolContract.wizard';

export const ContractStep = ({
  context: { product, contractBase },
  validate,
  submit,
}: WizardItemType.Config.Component<CreateNewMasterPoolContractWizardContext>) => {
  const { t, lang } = useTranslation();

  const [instance, setInstance] = useState<
    FormType.HandleEvent.Instance['value1'] | null
  >(null);

  useEffect(() => {
    if (instance) {
      instance.validateFields({
        validateOnly: true,
        dirty: false,
        recursive: true,
      });
    }
  }, [instance]);

  return (
    <Form
      data={{ value: contractBase }}
      config={{ validateOnChange: true }}
      handleEvent={{
        change: (value: any) => {
          let contractFormatted = value;

          if (value.startDate && product.period) {
            contractFormatted = {
              ...contractFormatted,
              endDate: DateTime.fromISO(value.startDate)
                .set({ millisecond: product.period })
                .toISO(),
            };
          }

          if (contractFormatted.APBMode === 'NONE') {
            contractFormatted = {
              ...contractFormatted,
              APBNext: null,
            };
          } else if (
            contractFormatted.APBMode !== 'NONE' &&
            [null, undefined].includes(contractFormatted.APBNext)
          ) {
            contractFormatted = {
              ...contractFormatted,
              APBNext: true,
            };
          }

          submit({ contractBase: contractFormatted });
        },
        validate: (value: boolean) => {
          validate(value);
        },
        instance: (form) => {
          setInstance(form);
        },
      }}
    >
      <Zone
        config={{
          gap: {
            y: 1,
            x: 1,
          },
          zones: [['info', 'form']],
          rows: ['1fr'],
          columns: ['min-content', '1fr'],
        }}
      >
        <Zone.Area config={{ area: 'info' }}>
          <ContractWizardInfos
            data={{
              productName: product.id ? t(`product-${product.id}-name`) : null,
              APBMode: contractBase.APBMode,
              APBNext:
                contractBase.APBMode !== 'NONE' ? contractBase.APBNext : null,
              state: contractBase.state,
              startDate: contractBase.startDate,
              endDate: contractBase.endDate,
              description: contractBase.description,
              reference: contractBase.reference,
              capacity: contractBase.capacity,
              articleCode: contractBase.articleCode,
            }}
          />
        </Zone.Area>

        <Zone.Area config={{ area: 'form' }}>
          {contractBase.articleCode && (
            <ContractBaseForm
              data={{ contract: contractBase }}
              config={{
                disabled: { endDate: typeof product.period === 'number' },
                articleCodes: product.articleCodes,
                withCapacity: true,
              }}
            />
          )}
        </Zone.Area>
      </Zone>
    </Form>
  );
};
